<template>
	<div
		class="flex h-6 w-6 items-center justify-center rounded-full transition-all"
		:class="{
			'border-separator-primary border-2': !model,
			'border-yellow border-7': model
		}"
	>
		<CheckIcon class="h-5 w-5 text-black" v-if="model" />
	</div>
</template>
<script setup lang="ts">
import CheckIcon from '@/assets/icons/check.svg'
const model = defineModel<boolean>()
</script>
